module.exports = __webpack_public_path__ + "img/abyssus00.7d3e750e.jpg";